import { MutationCache, QueryClient } from '@tanstack/react-query';

export function createQueryClient() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        staleTime: 60 * 1000,
      },
    },
    mutationCache: new MutationCache({
      onSuccess: async () => {
        await queryClient.invalidateQueries();
      },
    }),
  });

  return queryClient;
}

// eslint-disable-next-line import-x/no-mutable-exports
export let clientSideQueryClient: QueryClient;

if (typeof window !== 'undefined') {
  clientSideQueryClient = createQueryClient();
}
